// eslint-disable-next-line import/named
import { asMarkdownTemplate } from '../general/markdown';
import { html, TemplateResult } from 'lit';
import { LitBaseModal } from './modal/modal-factory-lit';
import { LangModalOption } from '../../../localization/webmodule-common/other/ui/modal-option-lang';

export interface OptionButton {
  caption: string;
  value: string;
  btnClass?: 'default' | 'primary' | 'success' | 'neutral' | 'warning' | 'danger' | 'text';
}

export async function information(
  message: string | TemplateResult,
  title?: string | TemplateResult,
  modalSize?: string
) {
  await askOption(
    message,
    [{ caption: LangModalOption.ok(), value: '' }],
    title ?? LangModalOption.information(),
    modalSize
  );
}

globalThis.informAsync = information;

export async function askOption(
  message: string | TemplateResult,
  buttons: OptionButton[],
  title?: string | TemplateResult,
  modalSize?: string
): Promise<string> {
  const modal: OptionDialog = new OptionDialog(message, buttons, title, modalSize);
  await modal.showModal();
  return modal.result;
}

// noinspection HtmlUnknownAttribute

class OptionDialog extends LitBaseModal {
  message: string | TemplateResult;
  result = '';
  buttons: OptionButton[];
  eventTitle: string | TemplateResult;
  _modalSize = 'modal-md';

  constructor(
    message: string | TemplateResult,
    buttons: OptionButton[],
    title?: string | TemplateResult,
    modalSize?: string
  ) {
    super();
    this.eventTitle = title ?? LangModalOption.confirm();
    this.message = message;
    this.buttons = buttons;
    if (modalSize) this._modalSize = modalSize;
  }

  protected get modalSize() {
    return this._modalSize;
  }

  title(): string | TemplateResult {
    return this.eventTitle;
  }

  footerTemplate(): TemplateResult {
    return html` ${this.buttons.map(b => this.buttonTemplate(b))} `;
  }

  buttonTemplate(b: OptionButton): TemplateResult {
    const event = () => {
      this.result = b.value;
      this.hideModal();
    };
    const btnClass = b.btnClass ?? 'primary';
    return html` <webmodule-button size="small" variant="${btnClass}" @click=${event}>${b.caption}</webmodule-button>`;
  }

  bodyTemplate() {
    if (typeof this.message === 'string') {
      return html` ${asMarkdownTemplate(this.message)} `;
    } else {
      return this.message;
    }
  }
}
